export const localStorageHelpers = {
    getFromLocalStorage: (key: string) => {
        // @ts-ignore
        return JSON.parse(localStorage.getItem(key))
    },
    saveToLocalStorage: (key: string, data: string) => {
        return localStorage.setItem(key, JSON.stringify(data))
    },
    deleteFromLocalStorage: (key: string) => {
        return localStorage.removeItem(key)
    },
}
